import { createContext } from "react";

const defaultContext = {
  isEnabled: false,
};

export const WizardClickstreamContext = createContext(defaultContext);
